import { feedItems } from '@/mocks/homeData';
import SectionHeading from './SectionHeading';
import FeaturedCard from './FeaturedCard';
import HotList from './HotList';
import ShortNewsStrip from './ShortNewsStrip';
import FeedCard from './FeedCard';

export default function DeepDiveFeed() {
  return (
    <section id="feed" className="w-full bg-background-50 border-b border-background-200">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <SectionHeading
          index="02"
          kicker="SHORT + CARDS"
          title="深扒速览：短讯与卡片并行，一次刷完当前所有线索"
          desc="左侧是本期主推的长图专题，右侧是近 24 小时的深扒热榜。下方的速览卡片按线索拆分，每条都能独立看懂前因后果。"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <div className="lg:col-span-8">
            <FeaturedCard />
          </div>
          <div className="lg:col-span-4">
            <HotList />
          </div>
        </div>

        <div className="mt-5 md:mt-6">
          <ShortNewsStrip />
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {feedItems.map((item) => (
            <FeedCard key={item.id} item={item} />
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="#community"
            className="inline-flex items-center gap-2 h-11 px-7 rounded-md border border-foreground-300 text-sm font-label text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-stack-line text-base"></i>
            展开更多深扒速览
          </a>
        </div>
      </div>
    </section>
  );
}